import type { TestNurturingMainTab } from 'app/pages/TestNurturingPage/types';

export const TEST_NURTURING_BASE_PATH = '/test-nurturing';
export const TEST_NURTURING_VIEW_PARAM = 'view';

const VIEW_JOURNEYS = 'journeys';
const VIEW_TEMPLATES = 'templates';

export function parseTestNurturingViewFromSearch(search: string): TestNurturingMainTab {
  const view = new URLSearchParams(search).get(TEST_NURTURING_VIEW_PARAM);
  if (view === VIEW_JOURNEYS) return 'journeys';
  if (view === VIEW_TEMPLATES) return 'templates';
  return 'journeys';
}

export function buildTestNurturingPath(view: TestNurturingMainTab): string {
  return `${TEST_NURTURING_BASE_PATH}?${TEST_NURTURING_VIEW_PARAM}=${view}`;
}

export function buildTestNurturingBreadcrumbs(
  view: TestNurturingMainTab,
  options?: { isActive?: boolean },
): Array<{ label: string; link: string; isActive: boolean }> {
  return [
    {
      label: 'Test nurturing',
      link: buildTestNurturingPath(view),
      isActive: options?.isActive ?? true,
    },
  ];
}
